import { TFunction } from 'i18next'
import React, { FC } from 'react'
import { similarHouseholdsGradients } from '../../../../constants/scoreboardConstants'

interface HouseholdItemProps {
	item: { label: string; value: number }
	type: 'points' | 'savings'
	index: number
	isLoading: boolean
	t: TFunction<'pages_saving', 'similarHouseholds'>
}

const HouseholdItem: FC<HouseholdItemProps> = ({
	item: { value, label },
	type,
	index,
	isLoading,
	t,
}) => {
	const gradient = similarHouseholdsGradients[index]

	const formattedValue = type === 'savings' ? value.toFixed(2).replace('.', ',') : value

	return (
		<div
			className={`flex flex-row justify-between items-center h-12 p-3 rounded-r-lg min-w-0 ${gradient.className} ${gradient.width} overflow-hidden`}
			style={{
				width: isLoading ? '1rem' : undefined,
				transition: 'width 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
			}}
		>
			{!isLoading && (
				<>
					<span className='text-base text-text-dark truncate min-w-0 flex-1 whitespace-nowrap overflow-hidden'>
						{label}
					</span>
					<span className='text-sm text-text-dark font-[300] flex flex-row items-center gap-1 flex-shrink-0 whitespace-nowrap'>
						<span>{formattedValue}</span>
						{type === 'savings' ? (
							<span>{t('savingsUnit')}</span>
						) : (
							<img src='/assets/star-dark.svg' alt='star' className='h-4 w-4' />
						)}
					</span>
				</>
			)}
		</div>
	)
}

export default HouseholdItem
